/**
 * Bornes de la réponse e-mail du Service client, partagées par le schéma Vine du backend
 * (`replyToTicketSchema`) et le composer du back-office (`validateReplyFiles`, `accept` du champ
 * fichier).
 */

export const EMAIL_REPLY_MAX_LENGTH = 20_000
export const EMAIL_REPLY_MAX_FILES = 5
export const EMAIL_REPLY_MAX_FILE_BYTES = 10 * 1024 * 1024
export const EMAIL_REPLY_MAX_TOTAL_BYTES = 20 * 1024 * 1024
export const EMAIL_REPLY_ALLOWED_EXTNAMES = [
  'jpg',
  'jpeg',
  'png',
  'gif',
  'webp',
  'heic',
  'pdf',
  'txt',
  'csv',
  'doc',
  'docx',
  'xls',
  'xlsx',
  'ppt',
  'pptx',
  'odt',
  'ods',
]
